import React from 'react';

const ScanningAnimationOverlay = () => {
  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden rounded-lg">
      {/* Scan Line */}
      <div
        className="absolute left-0 right-0 h-1 bg-white/50 shadow-[0_0_10px_rgba(255,255,255,0.8)] animate-scan"
        style={{
          // The animation defined in tailwind.config.js will handle the 'top' and 'opacity'
        }}
      ></div>
      {/* Optional: Add more subtle effects here, like a very faint grid or noise pattern if desired */}
    </div>
  );
};

export default ScanningAnimationOverlay;
